import { Component, OnInit, Input } from '@angular/core';
import { IHeaderCell } from '../../holders/header-cell.component';
import { Col } from '../../../utility/cols/col.class';
import { Tag } from '../../../utility/context/local/filter.class';


@Component({
   selector: 'app-text-header-cell',
   template: `
      <div class="title">
         <div>{{ col.title() }}</div>
         <div  *ngIf="col.ctx.cols.isDragable && !col.isPinned" 
               (mousedown)="col.ctx.dragger.mouseDown($event, col)"
               class="dragger"></div>
      </div>
      <button  *ngIf="col.sortable.isActive" 
               [icons]="'CRL:SORTER'" 
               [class]="'sort ' + col.sortable.state" 
               (click)="sort()"></button>
      <button  *ngIf="tags.size" 
               [icons]="'CRL:FILTER'"
               class="filter">
   `,
   styleUrls: ['./text.component.scss']
})
export class TextHeaderCellComponent implements IHeaderCell, OnInit {
   @Input() col: Col<object>;
   public tags: Set<Tag>;

   ngOnInit() {
      // this.tags = this.col.ctx.filter.getTagsByCol(this.col);
      this.tags = new Set();
   }


   public sort() {
      this.col.ctx.sorter.sortByCol(this.col);
   }
}
